// ── Custom hardware sensor extensions ──────────────────────────
// These are registered directly with the VM instead of going through
// the builtinExtensions map in scratch-vm (which lives in node_modules).
import Scratch3IRSensorBlocks from './hardware-sensors/ir-sensor/scratch3-ir-sensor';
import UltrasonicSensorExtension from './hardware-sensors/ultrasonic-sensor';
import ServoMotorExtension from './hardware-sensors/servo-motor';
import LEDActuatorExtension from './hardware-sensors/led-actuator';
import PIRSensorExtension from './hardware-sensors/pir-sensor';
import DHTSensorExtension from './hardware-sensors/dht-sensor';
import BuzzerActuatorExtension from './hardware-sensors/buzzer-actuator';
import WorldWeatherExtension from './hardware-sensors/world-weather';
import FaceDetectionExtension from './hardware-sensors/face-detection';
import ObjectDetectionExtension from './hardware-sensors/object-detection';
import SpeechRecognitionExtension from './hardware-sensors/speech-recognition';
import HumanBodyDetectionExtension from './hardware-sensors/human-body-detection';
import PosenetExtension from './hardware-sensors/posenet';
import AIServicesExtension from './hardware-sensors/ai-services';
import NLPExtension from './hardware-sensors/nlp';
import TTS2Extension from './hardware-sensors/tts-2';
import MachineLearningExtension from './hardware-sensors/ml-classifier';
import STT2Extension from './hardware-sensors/stt-2';
import GeminiLLMExtension from './hardware-sensors/gemini-llm';
import GenericDeviceExtension from './hardware-sensors/generic-device';
import MAX30105Extension from './hardware-sensors/max30105';
import DcMotorExtension from './hardware-sensors/dc-motor';
import OLEDDisplayExtension from './hardware-sensors/oled-display';
const customExtensions = {
    irSensor: Scratch3IRSensorBlocks,
    ultrasonicSensor: UltrasonicSensorExtension,
    servoMotor: ServoMotorExtension,
    ledActuator: LEDActuatorExtension,
    pirSensor: PIRSensorExtension,
    dhtSensor: DHTSensorExtension,
    buzzerActuator: BuzzerActuatorExtension,
    worldWeather: WorldWeatherExtension,
    faceDetection: FaceDetectionExtension,
    objectDetection: ObjectDetectionExtension,
    speechRecognition: SpeechRecognitionExtension,
    humanBodyDetection: HumanBodyDetectionExtension,
    posenet: PosenetExtension,
    aiServices: AIServicesExtension,
    naturalLanguageProcessing: NLPExtension,
    tts2: TTS2Extension,
    mlClassifier: MachineLearningExtension,
    stt2: STT2Extension,
    geminiLLM: GeminiLLMExtension,
    genericDevice: GenericDeviceExtension,
    max30105: MAX30105Extension,
    dcMotor: DcMotorExtension,
    oledDisplay: OLEDDisplayExtension
};

export default customExtensions;
